module.exports = __webpack_public_path__ + "static/media/GF-icon.6cf8aaa8.svg";